export default __webpack_public_path__ + "static/media/matt_on.60cec383.png";